import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import {
  ClipContext,
  ProfileContext,
  PinnedClipsContext,
  PlaylistContext,
} from "MVVM/Views/ClipExperience/@types";

export const useClipNavigate = () => {
  const history = useHistory();

  const navigateToClip = useCallback(
    (
      clipId: string,
      context?: ClipContext,
      useUrlParams = false,
      isMobile = false,
    ) => {
      const pathname = `/clip/${clipId}`;
      const searchParams = new URLSearchParams();

      if (isMobile) {
        searchParams.set("mobileView", "true");
        const fullPath = `${pathname}?${searchParams.toString()}`;

        history.push({
          pathname: fullPath,
          state: { autoplay: true, referrer: window.location.pathname },
        });
        return;
      }

      if (useUrlParams && context) {
        searchParams.set("context", context.type);

        if (isMobile) {
          searchParams.set("mobileView", "true");
        }

        if (context.type === "profile") {
          const profileContext = context as ProfileContext;
          if (profileContext.metadata.userId) {
            searchParams.set("userId", profileContext.metadata.userId);
            if (profileContext.metadata.tab) {
              searchParams.set("tab", profileContext.metadata.tab);
            }
            if (profileContext.metadata.source) {
              searchParams.set("source", profileContext.metadata.source);
            }
          }
        } else if (context.type === "pinned-clips") {
          const pinnedContext = context as PinnedClipsContext;
          if (pinnedContext.metadata?.userId) {
            searchParams.set("userId", pinnedContext.metadata.userId);
          }
          searchParams.set("tab", "recommended");
        } else if (context.type === "playlist") {
          const playlistContext = context as PlaylistContext;
          searchParams.set("playlistId", playlistContext.metadata.playlistId);
        }

        const search = searchParams.toString();
        const fullPath = search ? `${pathname}?${search}` : pathname;

        history.push({
          pathname: fullPath,
          state: { autoplay: true, referrer: window.location.pathname },
        });
      } else {
        history.push({
          pathname,
          state: {
            autoplay: true,
            referrer: window.location.pathname,
            context,
          },
        });
      }
    },
    [history],
  );

  const navigateToClipWithUrlParams = useCallback(
    (clipId: string, context?: ClipContext, isMobile = false) => {
      navigateToClip(clipId, context, true, isMobile);
    },
    [navigateToClip],
  );

  return { navigateToClip, navigateToClipWithUrlParams };
};
